export const formatCPF = (value: number | string): string => {
  const doc = typeof value === 'number' ? value.toString() : value;
  if (doc.length === 11) {
    return `${doc.slice(0, 3)}.${doc.slice(3, 6)}.${doc.slice(6, 9)}-${doc.slice(9, 11)}`;
  }
  return doc;
};
